/**
 * Enum controlling the underline behavior of links or text elements.
 */
export var UnderLineType;
(function (UnderLineType) {
    UnderLineType["None"] = "none";
    UnderLineType["OnHover"] = "onHover";
    UnderLineType["Underline"] = "underline";
})(UnderLineType || (UnderLineType = {}));
//# sourceMappingURL=UnderLineType.js.map